import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@simpl/element-ng/translate';
import { SiTranslateModule } from '@simpl/element-ng/translate';

class SiProgressbarComponent {
    /**
     * Needed for a11y
     */
    ariaLabel = $localize `:@@SI_PROGRESSBAR.LABEL:Progress`;
    /**
     * Max value for progressbar
     */
    max = 100;
    /**
     * Current value
     */
    value = 0;
    /**
     * Heading to display on top of progress bar.
     */
    heading;
    /**
     * Optional progress text to be shown on top right (in LTR).
     * It can be percentage value or a progress status. E.g `50 %` or `Downloading 2/8`.
     */
    progress;
    /**
     * Height for progress bar.
     */
    height = 'normal';
    percent = 0;
    ngOnChanges(changes) {
        if (changes.value || changes.max) {
            this.percent = (100 * Number(this.value ?? 0)) / Number(this.max ?? 100);
        }
    }
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiProgressbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
    static ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.1.5", type: SiProgressbarComponent, selector: "si-progressbar", inputs: { ariaLabel: "ariaLabel", max: "max", value: "value", heading: "heading", progress: "progress", height: "height" }, usesOnChanges: true, ngImport: i0, template: "<div\n  *ngIf=\"heading || progress\"\n  class=\"d-flex align-items-baseline\"\n  [class.justify-content-end]=\"!heading\"\n  [class.justify-content-between]=\"heading\"\n>\n  <span *ngIf=\"heading\" class=\"si-title-2 mb-2\">{{ heading | translate }}</span>\n  <small *ngIf=\"progress\" class=\"text-nowrap\">{{ progress }}</small>\n</div>\n<div class=\"progress\" [class.si-progress-small]=\"height === 'small'\">\n  <div\n    class=\"progress-bar\"\n    role=\"progressbar\"\n    [attr.aria-valuemin]=\"0\"\n    [attr.aria-valuemax]=\"max\"\n    [attr.aria-valuenow]=\"value\"\n    [attr.aria-valuetext]=\"value !== undefined ? percent.toFixed(0) + '%' : null\"\n    [attr.aria-label]=\"ariaLabel | translate\"\n    [style.width.%]=\"percent\"\n  >\n  </div>\n</div>\n", styles: [".si-progress-small{block-size:.125rem;border-radius:.0625rem}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i2.SiTranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiProgressbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'si-progressbar', changeDetection: ChangeDetectionStrategy.OnPush, template: "<div\n  *ngIf=\"heading || progress\"\n  class=\"d-flex align-items-baseline\"\n  [class.justify-content-end]=\"!heading\"\n  [class.justify-content-between]=\"heading\"\n>\n  <span *ngIf=\"heading\" class=\"si-title-2 mb-2\">{{ heading | translate }}</span>\n  <small *ngIf=\"progress\" class=\"text-nowrap\">{{ progress }}</small>\n</div>\n<div class=\"progress\" [class.si-progress-small]=\"height === 'small'\">\n  <div\n    class=\"progress-bar\"\n    role=\"progressbar\"\n    [attr.aria-valuemin]=\"0\"\n    [attr.aria-valuemax]=\"max\"\n    [attr.aria-valuenow]=\"value\"\n    [attr.aria-valuetext]=\"value !== undefined ? percent.toFixed(0) + '%' : null\"\n    [attr.aria-label]=\"ariaLabel | translate\"\n    [style.width.%]=\"percent\"\n  >\n  </div>\n</div>\n", styles: [".si-progress-small{block-size:.125rem;border-radius:.0625rem}\n"] }]
        }], propDecorators: { ariaLabel: [{
                type: Input
            }], max: [{
                type: Input
            }], value: [{
                type: Input
            }], heading: [{
                type: Input
            }], progress: [{
                type: Input
            }], height: [{
                type: Input
            }] } });

class SiProgressbarModule {
    static ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiProgressbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
    static ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.1.5", ngImport: i0, type: SiProgressbarModule, declarations: [SiProgressbarComponent], imports: [CommonModule, SiTranslateModule], exports: [SiProgressbarComponent] });
    static ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiProgressbarModule, imports: [CommonModule, SiTranslateModule] });
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.1.5", ngImport: i0, type: SiProgressbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, SiTranslateModule],
                    declarations: [SiProgressbarComponent],
                    exports: [SiProgressbarComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SiProgressbarComponent, SiProgressbarModule };
